// src/Components/logistics/CityModal.jsx
import { useState, useEffect } from "react";
import {
  Col,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Badge,
  Spinner,
  InputGroup,
  InputGroupText,
} from "reactstrap";
import { Btn } from "../../../AbstractElements";
import { toast } from "react-toastify";
import { NumericFormat } from "react-number-format";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { useProvinces } from "../../Hooks/use-locations";

export const CityModal = ({ isModalOpen, toggleModal, countryId, handleSaveCities, currency }) => {
  const [provinceId, setProvinceId] = useState("");
  const [selectedCities, setSelectedCities] = useState([]); // {id, name}
  const [shippingValue, setShippingValue] = useState("");

  const { getData } = useDataFetch();
  const { provinces } = useProvinces(countryId);

  const { data: citiesData, isLoading: loadingCities, refetch: fetchCities } = getData(
    ["cities-without-shipping", provinceId],
    `/logistics/cities-without-shipping/${provinceId}`,
    { enabled: !!provinceId }
  );

  const cities = citiesData?.data || [];

  useEffect(() => {
    if (provinceId) fetchCities();
  }, [provinceId]);

  const handleCityToggle = (city) => {
    setSelectedCities((prev) => {
      const exists = prev.find((c) => c.id === city.id);
      if (exists) {
        return prev.filter((c) => c.id !== city.id);
      } else {
        return [...prev, city];
      }
    });
  };

  const handleSave = async () => {
    if (!selectedCities.length) {
      toast.error("Selecciona al menos una ciudad");
      return;
    }
    if (!shippingValue) {
      toast.error("Ingresa un costo de envío");
      return;
    }

    try {
      await handleSaveCities(selectedCities.map((c) => c.id), Number(shippingValue));
      setProvinceId("");
      setShippingValue("");
      setSelectedCities([]);
    } catch (err) {
      console.error(err);
      toast.error("Error al guardar las ciudades");
    }
  };

  return (
    <Modal
      isOpen={isModalOpen}
      toggle={toggleModal}
      size="lg"
      centered
      backdrop="static"
      keyboard={false}
    >
      <ModalHeader toggle={toggleModal}>Registrar precios de ciudades</ModalHeader>
      <ModalBody>
        {/* Siempre mostramos el selector de provincia y el costo */}
        <Row className="mb-3">
          <Col md="6">
            <Label>Provincia</Label>
            <select
              className="form-control"
              value={provinceId}
              onChange={(e) => setProvinceId(e.target.value)}
            >
              <option value="">Selecciona una provincia</option>
              {provinces.map((p) => (
                <option key={p.id} value={p.id}>
                  {p.name}
                </option>
              ))}
            </select>
          </Col>
          <Col md="6">
            <Label>Costo de envío</Label>
            <InputGroup style={{ maxWidth: 250 }}>
              <NumericFormat
                className="form-control"
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={2}
                fixedDecimalScale
                allowNegative={false}
                value={shippingValue}
                onValueChange={(values) => setShippingValue(values.value)}
                placeholder="Ej: 5.000"
              />
              <InputGroupText>{currency || "$"}</InputGroupText>
            </InputGroup>
          </Col>
        </Row>

        {/* Mensaje grande cuando no hay provincia ni ciudades seleccionadas */}
        {!provinceId && selectedCities.length === 0 && (
          <div className="text-center py-5 w-100">
            <h4 className="fw-bold">Selecciona una provincia</h4>
            <p className="text-muted">
              Para registrar precios, primero debes elegir una provincia y luego seleccionar las ciudades disponibles.
            </p>
          </div>
        )}

        {/* Ciudades seleccionadas */}
        {selectedCities.length > 0 && (
          <div className="mb-3">
            <Label>Ciudades seleccionadas:</Label>
            <div>
              {selectedCities.map((c) => (
                <Badge key={c.id} color="primary" className="me-1 mb-1">
                  {c.name}
                </Badge>
              ))}
            </div>
          </div>
        )}

        {/* Listado de checkboxes */}
        {loadingCities ? (
          <Spinner size="sm" />
        ) : cities.length > 0 ? (
          <div className="d-flex flex-wrap" style={{ maxHeight: "300px", overflowY: "auto" }}>
            {cities.map((city) => (
              <div key={city.id} style={{ width: "33%", padding: "5px" }}>
                <div className="checkbox checkbox-dark">
                  <input
                    id={`city-${city.id}`}
                    type="checkbox"
                    value={city.id}
                    checked={selectedCities.some((c) => c.id === city.id)}
                    onChange={() => handleCityToggle(city)}
                  />
                  <Label htmlFor={`city-${city.id}`}>{city.name}</Label>
                </div>
              </div>
            ))}
          </div>
        ) : provinceId ? (
          <p>No hay ciudades disponibles en esta provincia.</p>
        ) : null}
      </ModalBody>


      <ModalFooter>
        <Btn attrBtn={{ color: "primary", onClick: handleSave }}>Guardar</Btn>
        <Btn attrBtn={{ color: "secondary", onClick: toggleModal }}>Cerrar</Btn>
      </ModalFooter>
    </Modal>
  );
};
